module.exports = __webpack_public_path__ + "media/images/banner1.1-c8f63d68a6e79561ef7dff06efefc218.jpg";